import { cn } from "@/lib/utils";
import { BaseIconProps } from "../Icon.model";

export default function CloseIcon({
  size = 40,
  fill,
  stroke,
  className,
  ...props
}: BaseIconProps) {
  return (
    <div className="group relative inline-block">
      {/* Default state - visible by default, hidden on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "transition-opacity duration-200 group-hover:opacity-0 group-focus:opacity-0",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14397_4132)">
          <circle
            cx="20"
            cy="20"
            r="19"
            stroke={stroke || "white"}
            strokeWidth="2"
            fill={fill || "none"}
          />
          <g clipPath="url(#clip1_14397_4132)">
            <path
              d="M27 14.41L25.59 13L20 18.59L14.41 13L13 14.41L18.59 20L13 25.59L14.41 27L20 21.41L25.59 27L27 25.59L21.41 20L27 14.41Z"
              fill={fill || stroke || "white"}
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_14397_4132">
            <rect width="40" height="40" fill="white" />
          </clipPath>
          <clipPath id="clip1_14397_4132">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>

      {/* Hover state - hidden by default, visible on hover/focus */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(
          "absolute top-0 left-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus:opacity-100",
          className,
        )}
        {...props}
      >
        <g clipPath="url(#clip0_14397_4294_hover)">
          <circle
            cx="20"
            cy="20"
            r="19"
            fill={stroke || "white"}
            stroke={stroke || "white"}
            strokeWidth="2"
          />
          <g clipPath="url(#clip1_14397_4294_hover)">
            <path
              d="M27 14.41L25.59 13L20 18.59L14.41 13L13 14.41L18.59 20L13 25.59L14.41 27L20 21.41L25.59 27L27 25.59L21.41 20L27 14.41Z"
              fill={stroke === "black" ? "white" : "black"}
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_14397_4294_hover">
            <rect width="40" height="40" fill="white" />
          </clipPath>
          <clipPath id="clip1_14397_4294_hover">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
